'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

define(['$window', 'app'], function ($window, app) {

  var responsivePagination = function responsivePagination() {
    var component = {};

    var _config = {
      selectors: {
        pageSelectorNumber: '[data-page-number]',
        pageActiveSelector: '[data-page-active]',
        nextPageButtonSelector: '[data-direction="next"]',
        prevPageButtonSelector: '[data-direction="previous"]'
      },
      attributes: {
        pageSelectorNumber: 'data-page-number'
      }
    };

    var _init = function _init(element) {
      component.element = element;

      component.pageSelectorElems = [].concat(_toConsumableArray(component.element.querySelectorAll(component.config.selectors.pageSelectorNumber)));
      component.nextPageButtonElems = [].concat(_toConsumableArray(component.element.querySelectorAll(component.config.selectors.nextPageButtonSelector)));
      component.prevPageButtonElems = [].concat(_toConsumableArray(component.element.querySelectorAll(component.config.selectors.prevPageButtonSelector)));

      component.bind();

      return component;
    };

    var _bind = function _bind() {
      component.pageSelectorElems.map(function (el) {
        return el.addEventListener('click', component.pageSelectorClicked);
      });
      component.nextPageButtonElems.map(function (el) {
        return el.addEventListener('click', component.nextPageButtonClicked);
      });
      component.prevPageButtonElems.map(function (el) {
        return el.addEventListener('click', component.prevPageButtonClicked);
      });
    };

    var _pageSelectorClicked = function _pageSelectorClicked(event) {
      var elem = event.target;
      var pageNumber = component.getPageNumberOf(elem);
      component.updatePageNumber(pageNumber);
    };

    var _nextPageButtonClicked = function _nextPageButtonClicked() {
      var currentPageElem = component.element.querySelector(component.config.selectors.pageActiveSelector);
      var currentPageNumber = component.getPageNumberOf(currentPageElem);
      component.updatePageNumber(parseInt(currentPageNumber) + 1);
    };

    var _prevPageButtonClicked = function _prevPageButtonClicked() {
      var currentPageElem = component.element.querySelector(component.config.selectors.pageActiveSelector);
      var currentPageNumber = component.getPageNumberOf(currentPageElem);
      component.updatePageNumber(parseInt(currentPageNumber) - 1);
    };

    var _getPageNumberOf = function _getPageNumberOf(pageNumberElem) {
      return pageNumberElem.getAttribute(component.config.attributes.pageSelectorNumber);
    };

    var _updatePageNumber = function _updatePageNumber(value) {
      app.publish('responsiveProductListPage/update', { pageNumber: value });
    };

    component.config = _config;
    component.init = _init;
    component.bind = _bind;
    component.pageSelectorClicked = _pageSelectorClicked;
    component.nextPageButtonClicked = _nextPageButtonClicked;
    component.prevPageButtonClicked = _prevPageButtonClicked;
    component.getPageNumberOf = _getPageNumberOf;
    component.updatePageNumber = _updatePageNumber;

    return component;
  };

  return responsivePagination;
});
//# sourceMappingURL=responsivePagination.js.map
